<template>
  <b-modal
    :visible="show"
    :title="title"
    :content-class="contentClass"
    :footer-class="footerClass"
    :header-class="headerClass"
    :header-bg-variant="headerBgVariant"
    :header-text-variant="headerTextVariant"
    :centered="centered"
    :hide-header-close="true"
    :no-close-on-backdrop="!backdropClose"
    :no-close-on-esc="!escClose"
    :size="size"
    :scrollable="scrollable"
  >
    <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>

    <template v-slot:modal-footer>
      <b-button
        squared
        :variant="cancelBtnVariant"
        :size="cancelBtnSize"
        :disabled="cancelBtnDisabled"
        @click="cancelBtn"
      >
        {{ cancelBtnText }}
      </b-button>
      <b-button
        squared
        :variant="okBtnVariant"
        :size="okBtnSize"
        :disabled="okBtnDisabled"
        @click="okBtn"
      >
        {{ okBtnText }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: 'Modal',
  props: {
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    modifiers: {
      type: Object,
      default: () => ({}),
    },
    centered: {
      type: Boolean,
      default: true,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
    cancelBtnOptions: {
      type: Object,
      default: () => ({}),
    },
    okBtnOptions: {
      type: Object,
      default: () => ({}),
    },
    backdropClose: {
      type: Boolean,
      default: false,
    },
    escClose: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
      validator(val) {
        return ['sm', 'md', 'lg', 'xl'].includes(val);
      },
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', () => {
      this.$store.dispatch('setModalShowing');
    });
    this.$root.$on('bv::modal::shown', () => {
      this.$store.dispatch('resetModalShowing');
    });
  },
  computed: {
    okBtnText() {
      return this.$get(this.okBtnOptions, 'text', 'OK');
    },
    cancelBtnText() {
      return this.$get(this.cancelBtnOptions, 'text', 'Cancel');
    },
    okBtnSize() {
      return this.$get(this.okBtnOptions, 'size', 'md');
    },
    cancelBtnSize() {
      return this.$get(this.cancelBtnOptions, 'size', 'md');
    },
    okBtnDisabled() {
      return this.$get(this.okBtnOptions, 'disabled', false);
    },
    cancelBtnDisabled() {
      return this.$get(this.cancelBtnOptions, 'disabled', false);
    },
    defaults() {
      return {
        contentClass: 'rounded-0 border-0',
        footerClass: 'd-flex justify-content-center',
        headerClass: 'rounded-0',
        headerBgVariant: 'primary',
        headerTextVariant: 'light',
        okBtnVariant: 'primary',
        cancelBtnVariant: 'secondary',
      };
    },
    okBtnVariant() {
      return this.$get(this.okBtnOptions, 'variant', this.defaults.okBtnVariant);
    },
    cancelBtnVariant() {
      return this.$get(this.cancelBtnOptions, 'variant', this.defaults.cancelBtnVariant);
    },
    headerClass() {
      return this.getModifierClass('headerClass');
    },
    contentClass() {
      return this.getModifierClass('contentClass');
    },
    footerClass() {
      return this.getModifierClass('footerClass');
    },
    headerBgVariant() {
      return this.getModifierClass('headerBgVariant');
    },
    headerTextVariant() {
      return this.getModifierClass('headerTextVariant');
    },
  },
  methods: {
    getModifierClass(modifierName) {
      const isObject = typeof this.modifiers[modifierName] === 'object';
      const overrideThis = this.$get(this.modifiers, `${modifierName}.override`, false);
      const classes = this.$get(this.modifiers, isObject ? `${modifierName}.class` : `${modifierName}`, '');
      return overrideThis ? classes : `${this.defaults[modifierName]} ${classes}`;
    },
    close() {
      this.$emit('update:show', false);
    },
    cancelBtn() {
      this.$emit('cancelBtn');
      this.close();
    },
    okBtn() {
      this.$emit('okBtn');
      this.close();
    },
  },
};
</script>
